const events = {
  replySent: "if-secure-messaging-reply-sent-to-conversation",
  replySendFailed: "if-secure-messaging-reply-send-to-conversation-failed",
  unauthorized: "if-secure-messaging-unauthorized",
  newMessageSentOrCancelled:
    "if-secure-messaging-new-message-sent-or-cancelled",
  newMessageStarted: "if-secure-messaging-new-message-started",
  replyMessageStarted: "if-secure-messaging-reply-message-started",
  newMessageSent: "if-secure-messaging-new-message-sent",
  newMessageFailed: "if-secure-messaging-new-message-failed",
  newMessageCancelled: "if-secure-messaging-new-message-cancelled",
};

export default events;
